import React from 'react'
import { Field } from 'redux-form'
import { renderTextField } from '../../Forms/fieldRenderers'
import { required, validarTelefono } from '../../Forms/fieldValidators'
import { Row, Col } from 'react-bootstrap'
import { Grid } from '@material-ui/core'

function CamposPerfil (props) {
  const {
    handleChangeEmail,
    handleChangeEmailNotificaciones,
    rolDeCupo
  } = props

  return (
    <div>
      <Row>
        <Grid container justify='center'>
          <Col md={6}>
            <h6><b>Información de Contacto</b></h6>
            <Field
              name='telefono'
              type='text'
              label='Número de teléfono'
              component={renderTextField}
              validate={[validarTelefono]}
              autoFocus={false}
              placeholder=''
            />
          </Col>
          <Col md={4} />
        </Grid>
      </Row>
      <Row>
        <Grid container justify='space-around'>
          <Col md={10}>
            <Field
              name='email'
              type='text'
              label='Correo electrónico *'
              component={renderTextField}
              autoFocus
              validate={[required]}
              placeholder=''
              onChange={(e) => handleChangeEmail(e)}
            />
            {(rolDeCupo.length > 0) &&
            <><br /><h6><b>Información para notificación de cupo</b></h6>
              <Field
                name='nombre'
                type='text'
                label='Apellido y Nombre'
                component={renderTextField}
                autoFocus={false}
              />
              <Field
                name='emailNotificaciones'
                type='text'
                label='Correo electrónico'
                component={renderTextField}
                autoFocus={false}
                placeholder=''
                onChange={(e) => handleChangeEmailNotificaciones(e)}
              />
            </>}
          </Col>
        </Grid>
      </Row>
      <Row>
        <Grid container justify='flex-end'>
          <p style={{ paddingRight: '15px' }}>(*) Campo requerido obligatorio</p>
        </Grid>
      </Row>
    </div>
  )
}

export default CamposPerfil
